import React, { useState, useEffect, useCallback, useRef, useContext } from "react";

import { Button, Col, Row, Space, Typography, Table,Pagination,theme } from "antd";
import { Content } from "antd/es/layout/layout";
import { useNavigate } from "react-router-dom";
import {
    
    DeleteFilled,
    EditOutlined,
    EyeFilled,
} from "@ant-design/icons";
import { SearchCustomerCompetitorContext } from "../searchContext";
import TextWithBR from "../../../../components/common/TextWithBR";
import NotFound from "../../../../components/common/notFound";
import { routes } from "../../../../routes";

const { Text } = Typography;
const { useToken } = theme;

const CustomerCompetitorTable = (value) =>{
    const [loading, setLoading] = useState(false);
    const { token } = useToken();
    const navigate = useNavigate();
    const { dataSource ,
      no,
      header,
      pageValues,
      onPageChange,  
    } = value;
    let number = no;
    const columns = [
    {
      title: "อันดับ",
      key: "no",
      width: 70,
      dataIndex: "no",
      render: (text, record, index) => <span>{(number += 1)}</span>,
    },
    {
      title: "ชื่อสถานประกอบการ/ชื่อโรงงาน",
      dataIndex: "factoryNameTh",
      key: "factoryNameTh",
      sorter: true,
      width: 150,
      render: (factoryNameTh, record) => (
        <>
          <TextWithBR
            line1={record.factoryNameTh}
            line2={record.factoryNameEn}
            color={"#82858E"}
          />
        </>
      ),
    },
    {
      title: "กลุ่มลูกค้าตามสัญชาติ",
      dataIndex: "customerGroupByRegion",
      key: "customerGroupByRegion",
      sorter: true,
      width: 300,
      render: (customerGroupByRegion, record) => (
        <>
          <Text>{record.customerGroupByRegion}</Text>
        </>
      ),
    },
    {
      title: "สัญชาติคู่แข่ง",
      dataIndex: "regionGroupName",
      key: "regionGroupName",
      sorter: true,
      width: 100,
      render: (customerRegion, record) => (
        <>
          <Text>{record.customerRegion}</Text>
        </>
      ),
    },
    {
      title: "การจัดการ",
      dataIndex: "action",
      key: "action",
      width: 150,
      render: (action, record) => (
        <Space>
          <>
            {/* {!roleUser[0]?.isEdit &&
              !roleUser[0].isDelete &&
              roleUser[0]?.isView && ( */}
                <Button
                  className="btn-view"
                  shape="circle"
                  icon={<EyeFilled style={{ color: "#2E90FA" }} />}
                  onClick={() =>
                    
                    navigate(header === "domestic" ? routes.view_customer_domestic_competitor : routes.view_customer_international_competitor, {
                      state: {
                        id: record.customerCompetitorId,
                        action_type: "VIEW",
                        
                      },
                      
                    })
                  }
                />
              {/* )} */}

            {/* {roleUser[0]?.isEdit && ( */}
              <Button
                className="btn-edit"
                shape="circle"
                icon={<EditOutlined style={{ color: "#F79009" }} />}
                onClick={() =>
                    
                    navigate(header === "domestic" ? routes.view_customer_domestic_competitor : routes.view_customer_international_competitor, {
                      state: {
                        id: record.customerCompetitorId,
                        action_type: "EDIT",
                        
                      },
                      
                    })
                  }
              />
            {/* )} */}
            {/* {roleUser[0]?.isDelete && ( */}
              <Button
                className="btn-delete"
                shape="circle"
                icon={<DeleteFilled style={{ color: "#F04438" }} />}
              />
            {/* )} */}
          </>
        </Space>
      ),
    },
  ];
return(
    <Content>
      <Row gutter={[24, 12]}>
        <Col span={24} style={{ margin: "20px 0px 10px 20px" }}>
          รายการทั้งหมด{" "}
          <span style={{ color: token.thPrimary, fontWeight: 700 }}>
            {pageValues?.total}
          </span>{" "}
          รายการ
        </Col>
        <Col span={24}>
          <Table
            locale={{ emptyText: <NotFound /> }}
            loading={loading}
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            scroll={{
              x: 2000,
            }}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>
    </Content>
    )
};

export default CustomerCompetitorTable;